const topicsData = [
  { name: '51吃瓜在线观看', count: '2.3万讨论', hot: true },
  { name: '91吃瓜最新视频', count: '1.8万讨论', hot: true },
  { name: '黑料吃瓜合集', count: '1.5万讨论', hot: true },
  { name: '明星恋情曝光', count: '1.2万讨论', hot: false },
  { name: '网红直播翻车', count: '9,800讨论', hot: true },
  { name: '综艺暗箱操作', count: '8,500讨论', hot: false },
  { name: '娱乐圈税务', count: '7,200讨论', hot: false },
  { name: '91在线吃瓜', count: '6,800讨论', hot: true },
  { name: 'CP营业真相', count: '5,900讨论', hot: false },
  { name: '年度吃瓜盘点', count: '5,100讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
            <i className="ri-hashtag text-background-50 text-lg"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门话题</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10">当前吃瓜圈最热门的讨论话题，点击即可浏览相关视频</p>

        <div className="flex flex-wrap gap-3">
          {topicsData.map((item, i) => (
            <a
              key={i}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-colors ${
                item.hot
                  ? 'bg-primary-50 text-primary-700 hover:bg-primary-100 border border-primary-200'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200/70 border border-background-200'
              }`}
            >
              <span className="text-sm font-medium">{item.name}</span>
              <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${
                item.hot ? 'bg-primary-100 text-primary-700' : 'bg-background-200 text-foreground-500'
              }`}>
                {item.count}
              </span>
              {item.hot && <i className="ri-fire-line text-primary-500 text-xs"></i>}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}